import type StateService from 'garaje/services/state';

/**
 * True when the current scope's billing subscription includes the given feature. Reads from the
 * billing REST features endpoint via the store-cached feature model on `state.features` — scope-
 * aware (location vs. company, MPB-aware).
 *
 * Feature names are the snake_case strings the billing endpoint returns (e.g. "threat_dashboard",
 * "analytics"). Same names the `@includes(...)` decorators on FeatureModel use.
 */
export function isBillingFeatureEnabled(feature: string, state: StateService): boolean {
  return state.features?.features?.includes(feature) ?? false;
}
